export const Data = [

  {
    id: 1,
    Photo: [
      {
          sectionTitle:"All",
          image:[
            {
              photo: "Gallery/All/t6.jpg",
            },
            {
              photo: "Gallery/All/team.jpg",
            },
            {
              photo: "Gallery/All/team1.jpg",
            },
        ]
        ,},
    ]
    },
{
    id: 2,
    Photo: [
      {
        sectionTitle:"Promethean 2020-21",
        image: [
          {
            photo: "Gallery/Prom 2020-21/Promethean 2020/a3.jpg",
          },
          {
            photo: "Gallery/Prom 2020-21/Promethean 2020/a2.jpg",
          },{
            photo: "Gallery/Prom 2020-21/Promethean 2020/a1.jpg",
          },{
            photo: "Gallery/Prom 2020-21/Promethean 2020/a4.jpg",
          },{
            photo: "Gallery/Prom 2020-21/Promethean 2020/a5.jpg",
          },{
            photo: "Gallery/Prom 2020-21/Promethean 2020/a6.jpg",
          },
      ],
      },
      {
        sectionTitle:"FE Induction",
        image: [
          {
            photo: "Gallery/Prom 2020-21/FE Induction/i1.jpg",
          },
          {
            photo: "Gallery/Prom 2020-21/FE Induction/i2.jpg",
          },{
            photo: "Gallery/Prom 2020-21/FE Induction/i3.jpg",
          },{
            photo: "Gallery/Prom 2020-21/FE Induction/i4.jpg",
          },{
            photo: "Gallery/Prom 2020-21/FE Induction/i5.jpg",
          },{
            photo: "Gallery/Prom 2020-21/FE Induction/i6.jpg",
          },
    ],
    },
      {
          sectionTitle:"Environment Day",
          image: [
            {
              photo: "Gallery/Prom 2020-21/Environment Day/terra1.jpg",
            },
            {
              photo: "Gallery/Prom 2020-21/Environment Day/terra2.jpg",
            },
            {
              photo: "Gallery/Prom 2020-21/Environment Day/terra3.jpg",
            },
            // {
            //   photo: "Gallery/Prom 2020-21/Environment Day/terra4.jpg",
            // },
      ],
      },
    {
    sectionTitle:"Team",
    image: [
      {
        photo: "Gallery/Prom 2020-21/Team/team.jpg",
      },
    ],
    },
    {
      sectionTitle:"Team Reveal",
      image: [
        {
          photo: "Gallery/Prom 2020-21/Team Reveal/teamteam.jpg",
        },
  ],
  },
  ]
},
{
    id: 3,
    Photo: [
      {
        sectionTitle:"Promethean 2021-22",
        image: [
          {
            photo: "Gallery/Prom 2021-22/Promethean/p1.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p2.jpg",
          },{
            photo: "Gallery/Prom 2021-22/Promethean/p3.jpg",
          },{
            photo: "Gallery/Prom 2021-22/Promethean/p4.jpg",
          },{
            photo: "Gallery/Prom 2021-22/Promethean/p5.jpg",
          },{
            photo: "Gallery/Prom 2021-22/Promethean/p6.jpg",
          },
          // {
          //   photo: "Gallery/Prom 2021-22/Promethean/p7.jpg",
          // },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p8.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p9.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p10.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p11.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p12.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p13.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p14.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p15.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p16.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p17.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p18.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p19.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p20.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p21.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/Promethean/p22.jpg",
          },
      ],
      },
      {
          sectionTitle:"Terra Talk",
          image: [
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra11.jpg",
            },
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra22.jpg",
            },
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra33.jpg",
            },
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra44.jpg",
            },
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra55.jpg",
            },
            {
              photo: "Gallery/Prom 2021-22/Terra Talk/terra66.jpg",
            },
            // {
            //   photo: "Gallery/Prom 2021-22/Terra Talk/terra77.jpg",
            // },
            
      ],
      },
      {
        sectionTitle:"FE Induction",
        image: [
          {
            photo: "Gallery/Prom 2021-22/FE induction/fe1.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/FE induction/fe2.jpg",
          },
          {
            photo: "Gallery/Prom 2021-22/FE induction/fe3.jpg",
          },
    ],
    },
   
    {
    sectionTitle:"Team",
    image: [
      {
        photo: "Gallery/Prom 2021-22/Team/team1.jpg",
      },
    ],
    },
    {
      sectionTitle:"Team Reveal",
      image: [
        {
          photo: "Gallery/Prom 2021-22/Team Reveal/imp1.jpg",
        },
        {
          photo: "Gallery/Prom 2021-22/Team Reveal/imp2.jpg",
        },
  ],
  },
  ]
    },
    {
      id: 4,
      Photo: [
      {
        sectionTitle:"Nisarg Campaign",
        image: [
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n1.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n2.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n3.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n4.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n5.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n6.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n7.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n8.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n9.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n10.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n11.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n12.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n13.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n14.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n15.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n16.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n17.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n18.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n19.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n20.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n21.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n22.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n23.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n24.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n25.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n26.jpg",
        },
        {
          photo: "Gallery/Prom 2022-23/Nisarg Campaign/n27.jpg",
        },
      ]
    },
    {
      sectionTitle:"Promethean Round 1",
      image: [
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p11.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p22.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p33.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p44.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p55.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p66.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p77.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p88.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p99.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p101.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p102.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p103.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p104.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p105.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p106.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p107.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p108.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p109.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p110.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p111.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p112.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p113.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p114.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p115.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p116.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p117.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R1/p118.jpg",
      },
    ],},
    {
      sectionTitle:"Promethean Round 2",
      image: [
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r1.jpg",
      },{
        photo: "Gallery/Prom 2022-23/Promethean R2/r2.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r3.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r4.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r5.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r6.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r7.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r8.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r9.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r10.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r11.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r12.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r13.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r14.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r15.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r16.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r17.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r18.JPG",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r18.JPG",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r20.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Promethean R2/r21.jpg",
      },
    ],
  },
  {
    sectionTitle:"Team",
    image: [
    {
      photo: "Gallery/Prom 2022-23/Team/t1.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/Team/t2.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/Team/t3.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/Team/t4.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/Team/t5.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/Team/t6.jpg",
    },
  ],},
  {
    sectionTitle:"Team Reveal",
    image: [
    {
      photo: "Gallery/Prom 2022-23/Team Reveal/team reveal.jpg",
    },
  ],
  },
  {
    sectionTitle:"Terra Talk",
    image: [
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax1.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax2.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax3.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax4.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax5.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax6.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax7.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax8.jpg",
      },{
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax9.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax10.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax11.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax12.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax13.jpg",
      },
      {
        photo: "Gallery/Prom 2022-23/Terra Talk/terrax14.jpg",
      },
  ],},
  {
    sectionTitle:"TML Launch Event",
    image: [
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l1.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l2.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l3.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l4.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l5.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l6.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l7.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/TML Launch/l8.jpg",
    },
  ],
  },
  {
    sectionTitle:"Behind the Scene",
    image: [
    {
      photo: "Gallery/Prom 2022-23/BTS/b9.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b8.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b7.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b10.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b11.png",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b12.png",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b13.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b14.png",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b15.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b16.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b17.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b18.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b19.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b20.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b21.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b1.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b2.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b3.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b4.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b5.jpg",
    },
    {
      photo: "Gallery/Prom 2022-23/BTS/b6.jpg",
    },
  ],
  },
  ]
},
{
    id: 5,
    Photo: [
        {
          sectionTitle:"FE Induction",
          image: [
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-1.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-2.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-3.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-4.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-5.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-6.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-7.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-8.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-9.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-10.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-11.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-12.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-13.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-14.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-15.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-16.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-17.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-18.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-19.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-20.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-21.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-22.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i23.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i24.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-25.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/FE Induction/i-26.jpg",
            },
          ],
        },
        {
          sectionTitle:"Matrix",
          image: [
            {
              photo: "Gallery/Prom 2023-24/Matrix/m1.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m2.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m3.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m4.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m5.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m6.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m7.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m8.JPG",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m9.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m10.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Matrix/m11.jpg",
            },
          ],
        },
        {
          sectionTitle:"SustainX",
          image: [
            {
              photo: "Gallery/Prom 2023-24/SustainX/Coming_soon.png",
            },
          ],
        },
        {
          sectionTitle:"Team",
          image: [
            {
              photo: "Gallery/Prom 2023-24/Team/t11.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Team/t22.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Team/t33.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Team/t44.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Team/t55.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/Team/t66.jpg",
            },
          ],
        },
        {
          sectionTitle:"Team Reveal",
          image: [
            {
              photo: "Gallery/Prom 2023-24/Team Reveal/team promethean final.png",
            },
          ],
        },
        {
          sectionTitle:"Tml event",
          image: [
            {
              photo: "Gallery/Prom 2023-24/SustainX/Coming_soon.png",
            },
          ],
        },
        {
          sectionTitle:"Tml launch",
          image: [
            {
              photo: "Gallery/Prom 2023-24/SustainX/Coming_soon.png",
            },
          ],
        },
        {
          sectionTitle:"Behind The Scenes",
          image: [
            {
              photo: "Gallery/2023_24/b1.jpg",
            },
            {
              photo: "Gallery/2023_24/b2.jpg",
            },
            {
              photo: "Gallery/2023_24/b3.jpg",
            },
            {
              photo: "Gallery/2023_24/b4.jpg",
            },
            {
              photo: "Gallery/2023_24/b5.jpg",
            },
            {
              photo: "Gallery/2023_24/b6.jpg",
            },
            {
              photo: "Gallery/2023_24/b7.jpg",
            },
            {
              photo: "Gallery/2023_24/b8.jpg",
            },
            {
              photo: "Gallery/2023_24/b9.jpg",
            },
            {
              photo: "Gallery/2023_24/b10.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b11.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b22.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b33.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b44.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b55.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b66.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b77.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b88.jpg",
            },
            {
              photo: "Gallery/Prom 2023-24/BTS/b99.jpg",
            },
          ],
        },
    ]
  },  
]
